import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  AllocationSheetsServiceProxy,
  GetImpactedWorkEventForViewDto,
  GetLocationForViewDto,
  GetWeatherPhenomenaForViewDto,
  ImpactedWorkEventEditDto,
  ImpactedWorkEventsServiceProxy,
  LocationsServiceProxy,
  WeatherPhenomenasServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import * as moment from 'moment';
import { AllocationConditionsFormFacade } from '@app/components/allocation-sheets/allocation/allocation-conditions/allocation-conditions-form/allocation-conditions-form.facade';
import { take, takeUntil } from '@node_modules/rxjs/operators';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';

@Component({
  selector: 'app-allocation-conditions-form',
  templateUrl: './allocation-conditions-form.component.html',
  styleUrls: ['./allocation-conditions-form.component.less'],
  providers: [AllocationConditionsFormFacade],
})
export class AllocationConditionsFormComponent
  extends AppComponentBase
  implements OnInit {
  @Input() sheetData;
  @Input() enrolledWorkDay;
  @Output() refreshData: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('weatherSelector', { static: false }) weatherSelector: MatSelect;
  @ViewChild('impactedWorkSelector', { static: false })
  impactedWorkSelector: MatSelect;

  open = true;

  locationsList: GetLocationForViewDto[];
  weatherPhenomenasList: GetWeatherPhenomenaForViewDto[];
  impactedWorkEvents: GetImpactedWorkEventForViewDto[];

  public weatherFormCtrl: FormControl = new FormControl();
  public filteredWeather: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public impactedWorkFormCtrl: FormControl = new FormControl();
  public filteredImpactedWork: ReplaySubject<any[]> = new ReplaySubject<any[]>(
    1
  );

  moment: any = moment;
  dateFormat: string = 'DD/MM/yyyy';
  shiftEndDateArray: string[];
  shiftEndDate: Date;
  shiftStart: string;
  endMinTime: string;
  shiftEnd: string;
  nightShift: boolean;
  rainfall: number;
  locationId: string;
  workSummary: string;
  weatherId: string = '';
  impactedWorkId: string = '';

  protected _onDestroy = new Subject<void>();

  constructor(
    injector: Injector,
    private _locations: LocationsServiceProxy,
    private _weatherPhenomenasServiceProxy: WeatherPhenomenasServiceProxy,
    private _impactedWorkServiceProxy: ImpactedWorkEventsServiceProxy,
    private cdr: ChangeDetectorRef,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private facade: AllocationConditionsFormFacade,
    private _projectService: ProjectService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getViewData();

    //Temp fix for 1693
    if(this.workSummary == null)
    {
      this.workSummary = "";
    }
    else if( this.workSummary.length == 0)
    {
      this.workSummary = "";
    }
    else
    {
      this.workSummary = this.workSummary;
    }
  }

  setInitialWeatherSelectorValue() {
    if (this.weatherSelector) {
      this.filteredWeather
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe(() => {
          this.weatherSelector.compareWith = (a: any, b: any) => {
            return a && b && a.weatherPhenomena.id === b.weatherPhenomena.id;
          };
        });
    }

    if (this.impactedWorkSelector) {
      this.filteredImpactedWork
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe(() => {
          this.impactedWorkSelector.compareWith = (a: any, b: any) => {
            return a && b && a.impactedWorkEvent.id === b.impactedWorkEvent.id;
          };
        });
    }
  }

  async getViewData() {
    forkJoin({
      weatherPhenomenas: this._weatherPhenomenasServiceProxy.getAll(
        null,
        null,
        'Name',
        0,
        99999
      ),
      locations: this._locations.getAll(null, null, null,null,null,null,null,'Name', 0, 999999),
      impactedWork: this._impactedWorkServiceProxy.getAll(
        null,
        null,
        'Name',
        0,
        999999
      ),
    }).subscribe((data) => {
      this.weatherPhenomenasList = data.weatherPhenomenas.items;
      this.locationsList = data.locations.items;
      this.impactedWorkEvents = data.impactedWork.items;

      this.initForm(this.enrolledWorkDay);
    });
  }

  getDescription(enrolledWorkDay, eventId: string): string {
    let result = null;

    enrolledWorkDay.eventsImpactedWork.forEach((e) => {
      if (e.impactedWorkEventId == eventId) {
        result = e.description;
      }
    });

    return result;
  }

  initForm(enrolledWorkDay): void {
    this.filteredWeather.next(this.weatherPhenomenasList.slice());

    const categories = this.impactedWorkEvents.map((item: any) => {
      return {
        enrolledWorkDayId: this.enrolledWorkDay.enrolledWorkDayId,
        impactedWorkEventId: item.impactedWorkEvent.id,
        impactedWorkEvent: {
          name: item.impactedWorkEvent.name,
          id: item.impactedWorkEvent.id,
        },
        description: this.getDescription(
          this.enrolledWorkDay,
          item.impactedWorkEvent.id
        ),
      };
    });

    this.filteredImpactedWork.next(categories.slice());

    this.cdr.detectChanges();

    if (enrolledWorkDay.locationId) {
      this.locationId = enrolledWorkDay.locationId;
    }
    if (enrolledWorkDay.enrolledWorkDayWeather.conditions.length > 0) {
      this.weatherId = enrolledWorkDay.enrolledWorkDayWeather.conditions[0].id;
    }
    if (enrolledWorkDay.eventsImpactedWork.length > 0) {
      this.impactedWorkId =
        enrolledWorkDay.eventsImpactedWork[0].impactedWorkEventId;
    }

    if (enrolledWorkDay.shiftStart) {
      this.shiftStart = moment(this.enrolledWorkDay.shiftStart).format('HH:mm');
      this.endMinTime = this.shiftStart;
    }

    if (enrolledWorkDay.shiftEnd) {
      this.shiftEnd = moment(this.enrolledWorkDay.shiftEnd).format('HH:mm');
    }
    this.shiftEndDateArray = [];
    this.shiftEndDateArray.push(this.enrolledWorkDay.workDay.format(this.dateFormat));
    this.shiftEndDateArray.push(this.enrolledWorkDay.workDay.clone().add(1, 'days').format(this.dateFormat));
    this.shiftEndDate = this.enrolledWorkDay.shiftEnd ? this.enrolledWorkDay.shiftEnd.format(this.dateFormat) : this.enrolledWorkDay.workDay.format(this.dateFormat);
    this.nightShift = this.enrolledWorkDay.isNightShift;

    if (enrolledWorkDay.workSummary) {
      this.workSummary = this.enrolledWorkDay.workSummary;
    }

    if (
      enrolledWorkDay.enrolledWorkDayWeather &&
      this.enrolledWorkDay.enrolledWorkDayWeather.hasOwnProperty('rainfall')
    ) {
      this.rainfall = this.enrolledWorkDay.enrolledWorkDayWeather.rainfall;
    }

    if (
      enrolledWorkDay.enrolledWorkDayWeather &&
      enrolledWorkDay.enrolledWorkDayWeather.conditions
    ) {
      this.weatherFormCtrl.setValue(
        enrolledWorkDay.enrolledWorkDayWeather.conditions.map((item) => {
          return { weatherPhenomena: item };
        })
      );
    }

    if (enrolledWorkDay.eventsImpactedWork) {
      this.impactedWorkFormCtrl.setValue(
        enrolledWorkDay.eventsImpactedWork.map((item) => {
          return {
            enrolledWorkDayId: item.enrolledWorkDayId,
            impactedWorkEventId: item.impactedWorkEvent.id,
            impactedWorkEvent: {
              name: item.impactedWorkEvent.name,
              id: item.impactedWorkEvent.id,
            },
            description: item.description,
          };
        })
      );

      this.cdr.detectChanges();
    }
  }

  updateLocation(locationId) {
    this.facade
      .updateLocation(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        locationId
      )
      .subscribe(() => {
        this.emitNextButtonStatus();
      });
  }

  updateShiftStart(_value) {
    if (!_value || _value == '') return;

    let shiftStartAt = null;
    if (moment(_value, ['HH:mm']).isValid()) {
    //   shiftStartAt = moment(_value, ['h:mm A']);
      shiftStartAt = moment(`${this.enrolledWorkDay.workDay.format(this.dateFormat)} ${_value}`, [`${this.dateFormat} h:mm A`]);
    }

    if (!shiftStartAt) return;

    this.facade
      .updateShiftStart(
        _value,
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        shiftStartAt
      )
      .subscribe(() => {
        this.emitNextButtonStatus();
      });
  }

  updateShiftEnd(_value) {
    if(this.enrolledWorkDay.workDay.format(this.dateFormat) == this.shiftEndDate){
        this.endMinTime = this.shiftStart;
      }else{
        this.endMinTime = "00:00";
    }

    if (!_value || _value == '') return;

    let shiftEndAt = null;
    if (moment(_value, ['HH:mm']).isValid()) {
      shiftEndAt = moment(`${this.shiftEndDate} ${_value}`, [`${this.dateFormat} h:mm A`]);;
    }

    this.facade
      .updateShiftEnd(
        _value,
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        shiftEndAt
      )
      .subscribe(() => {
        this.emitNextButtonStatus();
      });
  }

  updateNightShift(_value) {
    this.facade
      .updateNightShift(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        [_value]
      )
      .subscribe(() => {});
  }

  updateWeatherConditions(id) {
    this.facade
      .updateWeatherConditions(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        [id]
      )
      .subscribe(() => {});
  }

  get hasWeatherValue(){
    return this.weatherFormCtrl.value && this.weatherFormCtrl.value.length > 0;
  }

  updateWorkSummary() {
    this.facade
      .updateWorkSummary(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        this.workSummary
      )
      .subscribe(() => {
        this.emitNextButtonStatus();
      });
  }

  updateRainfall() {
    this.facade
      .updateRainfall(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        parseInt(this.rainfall.toString()) || 0
      )
      .subscribe(() => {
        this.emitNextButtonStatus();
      });
  }

  updateImpactedWork(id,description) {
    let x:ImpactedWorkEventEditDto =
     new ImpactedWorkEventEditDto({impactedWorkEventId: id,description:description});
    this.facade
      .updateImpactedWork(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay,
        [x]
      )
      .subscribe(() => { this.emitNextButtonStatus();});
  }

  copyConditionsToAllWorkDays() {
    this.facade
      .copyConditionsToAllWorkDays(
        this.sheetData.allocationSheetId,
        this.enrolledWorkDay.workDay
      )
      .subscribe(() => {
        this.emitNextButtonStatus(false);
      });
  }

  togglePanel() {
    this.open = !this.open;
    this.cdr.detectChanges();

    this.setInitialWeatherSelectorValue();
  }

  emitNextButtonStatus(flag = true) {
    if(flag){
      this.refreshData.emit({ onlyStatusEmit: true });
    }else{
      this.refreshData.emit({ onlyStatusEmit: false });
    }

  }
}
